import { DayOfWeek } from 'core/day-of-week';
export const AllWorkingDayConfig = {
    [DayOfWeek.Monday]: true,
    [DayOfWeek.Tuesday]: true,
    [DayOfWeek.Wednesday]: true,
    [DayOfWeek.Thursday]: true,
    [DayOfWeek.Friday]: true,
    [DayOfWeek.Saturday]: true,
    [DayOfWeek.Sunday]: true
};
const isNonWorkingDay = (date, workingDays)=>!workingDays[date.locale('en').format('dddd')];
export const getDateAfterSomeNumberOfWorkingDays = (startDate, numberOfDays, workingDays)=>{
    let daysLeft = numberOfDays;
    let currentDate = startDate.clone();
    while(daysLeft > 0){
        currentDate = currentDate.add(1, 'day');
        if (!isNonWorkingDay(currentDate, workingDays)) {
            daysLeft -= 1;
        }
    }
    return currentDate;
};
